export default __webpack_public_path__ + "static/media/ultrapayments.522965df.ico";